export default __webpack_public_path__ + "static/media/ddos_level.86196afa.svg";